module.exports = __webpack_public_path__ + "img/D202403_1.0f25a7ba.jpg";